import { useCallback, useState } from "react";

import type { IGoogleAdsAdGroupListItem } from "./use-google-ads-ad-groups";

interface IUseGoogleAdsAdGroupSelectionReturn {
    selectedAdGroup: IGoogleAdsAdGroupListItem | null;
    selectAdGroup: (adGroup: IGoogleAdsAdGroupListItem) => void;
    resetAdGroup: () => void;
}

export const useGoogleAdsAdGroupSelection = (): IUseGoogleAdsAdGroupSelectionReturn => {
    const [selectedAdGroup, setSelectedAdGroup] = useState<IGoogleAdsAdGroupListItem | null>(null);

    const selectAdGroup = useCallback((adGroup: IGoogleAdsAdGroupListItem) => setSelectedAdGroup(adGroup), []);
    const resetAdGroup = useCallback(() => setSelectedAdGroup(null), []);

    return { selectedAdGroup, selectAdGroup, resetAdGroup };
};
